import { LoadState } from "../../../constants/enums";

export interface IHabitationalPaymentAuthorizationState {
  data: IHabitationalPaymentAuthorization[];
  payAuth: IHabitationalPaymentAuthorization;
  payAuthLoading: LoadState;
  loading: LoadState;
  error: string | null;
}

export interface IHabitationalPaymentAuthorization {
  customer_policy_id: number;
  customer_id: number | null;
  serial_number: string | null;
  applicant_name: string | null;
  applicant_address: string | null;
  applicant_unit_or_suite: string | null;
  applicant_city: string | null;
  applicant_province_or_state: string | null;
  applicant_postal_code: string | null;
  applicant_contact_number: string | null;
  applicant_preferred_document_language: string | null;
  applicant_email_address: string;
  applicant_website_address: string;
  brokerage_branch_name: string | null;
  brokerage_full_address: string | null;
  brokerage_postal_code: string | null;
  brokerage_broker_code: string | null;
  brokerage_contact_name: string | null;
  brokerage_phone_number: string | null;
  brokerage_fax_number: string | null;
  brokerage_contract_number: string | null;
  brokerage_sub_contract_number: string | null;
  brokerage_group_or_program_name: string | null;
  brokerage_group_id: string | null;
  brokerage_broker_client_id: string | null;
  brokerage_company_client_id: string | null;
  insurance_company_name: string | null;
  insurance_company_address: string | null;
  insurance_company_unit_or_suite: string | null;
  insurance_company_province_or_state: string | null;
  insurance_company_postal_code: string | null;
  insurance_company_country: string | null;
  insurance_company_city: string | null;
  unit_or_suite: string | null;
  city: string | null;
  state_or_province: string | null;
  postal_code: string | null;
  country: string | null;
  policy_number: string | null;
  request_type: string | null;
  broker_code: string | null;
  total_estimated_policy_premium: string | null;
  installment_fee: number | null;
  tax_percentage: number | null;
  tax: string | null;
  percentage_finance: number | null;
  finance_charges: string | null;
  total_estimated_cost: string | null;
  mode_of_payment: string | null;
  plan_type: string | null;
  bank_name: string | null;
  bank_account_number: string | null;
  bank_transit_number: string | null;
  bank_institution_number: string | null;
  bank_address: string | null;
  bank_unit_or_suite: string | null;
  bank_city: string | null;
  bank_state_or_province: string | null;
  bank_postal_code: string | null;
  account_holder_name: string | null;
  account_holder_address: string | null;
  account_holder_unit_or_suite: string | null;
  account_holder_city: string | null;
  account_holder_state_or_province: string | null;
  account_holder_postal_code: string | null;
  type_of_payment: string | null;
  down_payment_amount: string | null;
  insurance_company_additional_charges: string | null;
  broker_additional_charges: string | null;
  full_payment_amount: string | null;
  installment_amount: string | null;
  next_payment_date: string | null;
  authorization: boolean | null;
  signature: string | null;
  status: string | null;
}

export const defaultHabitationalPaymentAuthorizationState: IHabitationalPaymentAuthorizationState =
  {
    data: [],
    loading: LoadState.NotLoaded,
    payAuth: {
      customer_policy_id: 0,
      customer_id: null,
      serial_number: null,
      applicant_name: null,
      applicant_address: null,
      applicant_unit_or_suite: null,
      applicant_city: null,
      applicant_province_or_state: null,
      applicant_postal_code: null,
      applicant_contact_number: null,
      applicant_preferred_document_language: null,
      applicant_email_address: "",
      applicant_website_address: "",
      brokerage_branch_name: null,
      brokerage_full_address: null,
      brokerage_postal_code: null,
      brokerage_broker_code: null,
      brokerage_contact_name: null,
      brokerage_phone_number: null,
      brokerage_fax_number: null,
      brokerage_contract_number: null,
      brokerage_sub_contract_number: null,
      brokerage_group_or_program_name: null,
      brokerage_group_id: null,
      brokerage_broker_client_id: null,
      brokerage_company_client_id: null,
      insurance_company_name: null,
      insurance_company_address: null,
      insurance_company_unit_or_suite: null,
      insurance_company_province_or_state: null,
      insurance_company_postal_code: null,
      insurance_company_country: null,
      insurance_company_city: null,
      unit_or_suite: null,
      city: null,
      state_or_province: null,
      postal_code: null,
      country: null,
      policy_number: null,
      request_type: null,
      broker_code: null,
      total_estimated_policy_premium: null,
      installment_fee: null,
      tax_percentage: null,
      tax: null,
      percentage_finance: null,
      finance_charges: null,
      total_estimated_cost: null,
      mode_of_payment: null,
      plan_type: null,
      bank_name: null,
      bank_account_number: null,
      bank_transit_number: null,
      bank_institution_number: null,
      bank_address: null,
      bank_unit_or_suite: null,
      bank_city: null,
      bank_state_or_province: null,
      bank_postal_code: null,
      account_holder_name: null,
      account_holder_address: null,
      account_holder_unit_or_suite: null,
      account_holder_city: null,
      account_holder_state_or_province: null,
      account_holder_postal_code: null,
      type_of_payment: null,
      down_payment_amount: null,
      insurance_company_additional_charges: null,
      broker_additional_charges: null,
      full_payment_amount: null,
      installment_amount: null,
      next_payment_date: null,
      authorization: false,
      signature:
        "I/We hereby authorize the named financial institution above to debit my/our account for all payments payable to",
      status: "ACTIVE",
    },
    payAuthLoading: LoadState.NotLoaded,
    error: null,
  };
